import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { Dropdown, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import logo from "../assets/images/thumb-Sri My - Logo png 1.png";
import { SlMagnifier } from "react-icons/sl";
import { CgProfile } from "react-icons/cg";
import { IoCartOutline } from "react-icons/io5";
import { axiosInstance } from "../axiosInstance";
import { MdLogin } from "react-icons/md";
import { useSelector } from "react-redux";
import { ShoppingCart } from "../pages/Cart";

export function Header() {
  // const cartItems = useSelector((state) => state.cart.cartItems);

  const [showClothing, setShowClothing] = useState(false);
  const [offcanvasShow, setOffcanvasShow] = useState(false);

  const handleClose = () => setOffcanvasShow(false);
  const handleShow = () => setOffcanvasShow(true);

  const [header, setHeader] = useState();
  const [cartcount, setcartCount] = useState([]);

  const token = localStorage.getItem("token");

  function loadHeader() {
    axiosInstance.get("/dashboardTypes").then((response) => {
      setHeader(response.data.data);
    });
  }
  //  async function cartCount() {
  //   const user_id=localStorage.getItem("user_id");
  //   const response = await axiosInstance.get(`/getCartdata/${user_id}`);
  //   const cartItems = response.data.data;
  //   setcartCount(cartItems.length);
  //   console.log("length", cartItems.length);
  //   // <ShoppingCart updateHeader={cartCount()}/>

  //  }
  async function getCartDetails() {
    const userid = localStorage.getItem("user_id");
    try {
      const response = await axiosInstance.get(`/getCartdata/${userid}`);
      const data = response.data.data;
      // Set the cart count (accessing the 'count' value separately)
      const count = data.find((item) => item.count)?.count || 0; // Grabbing count from the response data
      setcartCount(count);
      // <ShoppingCart headerCart={getCartDetails()}/>
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getCartDetails();
  }, []);

  useEffect(() => {
    loadHeader();
    if (window.innerWidth <= 768) {
      setShowClothing(true); // open dropdown by default in mobile
    }
  }, []);
  console.log(header);

  const handleMouseEnter = (setter) => {
    if (window.innerWidth > 768) {
      setter(true);
    }
  };

  const handleMouseLeave = (setter) => {
    if (window.innerWidth > 768) {
      setter(false);
    }
  };

  const handleToggle = (setter, isOpen) => {
    if (window.innerWidth <= 768) {
      setter(true);
    } else {
      setter(isOpen);
    }
  };

  const handleLinkClick = () => {
    handleClose(); // Close Offcanvas on link click
  };

  return (
    <>
      <Navbar
        expand="lg"
        style={{ backgroundColor: "white", borderBottom: "1px solid #E6E6E6" }}
        sticky="top"
      >
        <Container fluid>
          <Navbar.Toggle onClick={handleShow} />
          <Navbar.Brand href="/" className="navbrand-logo">
            <img src={logo} alt="logo" />
          </Navbar.Brand>

          <Navbar.Offcanvas
            show={offcanvasShow}
            onHide={handleClose}
            id="offcanvasNavbar-expand-lg"
            aria-labelledby="offcanvasNavbarLabel-expand-lg"
            placement="start"
          >
            <Offcanvas.Header closeButton>
              {/* <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
              Menu
            </Offcanvas.Title> */}
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-start flex-grow-1 pe-3">
                <div>
                  <Link to="/" className="homeBtn" onClick={handleLinkClick}>
                    HOME
                  </Link>
                </div>

                <div className="me-4">
                  <Dropdown
                    onMouseEnter={() => handleMouseEnter(setShowClothing)}
                    onMouseLeave={() => handleMouseLeave(setShowClothing)}
                    onToggle={(isOpen) => handleToggle(setShowClothing, isOpen)}
                    show={showClothing}
                  >
                    <Dropdown.Toggle variant="primary" id="dropdown-clothing">
                      CLOTHING
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {/* {["Sarees", "Co-ord’s", "Skirts", "short tops / shirts", "Bottoms", "Dresses", "Dupatta / stole", "kurtis"].map((item, index) => (
                      <Dropdown.Item key={index} className="dropdownList-bg" onClick={handleLinkClick}>
                        <Link to="/saree" className="homeBtn">
                          {item}
                        </Link>
                      </Dropdown.Item>
                    ))} */}
                      {header?.CLOTHING?.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          className="dropdownList-bg"
                          onClick={handleLinkClick}
                        >
                          <Link to="/saree" className="homeBtn">
                            {item.name}
                          </Link>
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <div>
                  <Link
                    to="/fabrics"
                    className="homeBtn"
                    onClick={handleLinkClick}
                  >
                    FABRICS
                  </Link>
                </div>
                <div>
                  <Link
                    to="/services"
                    className="homeBtn"
                    onClick={handleLinkClick}
                  >
                    SERVICES
                  </Link>
                </div>
                <div>
                  <Link
                    to="/about"
                    className="homeBtn"
                    onClick={handleLinkClick}
                  >
                    ABOUT US
                  </Link>
                </div>
                <div>
                  <Link
                    to="/contact"
                    className="homeBtn"
                    onClick={handleLinkClick}
                  >
                    CONTACT US
                  </Link>
                </div>
              </Nav>
              <Nav className="navIcons-container">
                <Nav.Link as="span">
                  {token ? (
                    <Link className="icon" onClick={handleLinkClick}>
                      <SlMagnifier />
                    </Link>
                  ) : (
                    <Link
                      to="/login"
                      className="icon"
                      onClick={handleLinkClick}
                    >
                      <SlMagnifier />
                    </Link>
                  )}
                </Nav.Link>
                <Nav.Link as="span">
                  {token ? (
                    <Link
                      to="/profile"
                      className="icon"
                      onClick={handleLinkClick}
                    >
                      <CgProfile />
                    </Link>
                  ) : (
                    <Link
                      to="/login"
                      className="icon"
                      onClick={handleLinkClick}
                    >
                      <MdLogin />
                      {/* login */}
                    </Link>
                  )}
                </Nav.Link>
                <Nav.Link as="span">
                  {token ? (
                    <div className="d-flex">
                      <Link
                        to="/cart"
                        className="icon"
                        onClick={handleLinkClick}
                      >
                        <IoCartOutline />
                      </Link>
                      <span className="cartCount">{cartcount}</span>
                    </div>
                  ) : (
                    <Link
                      to="/login"
                      className="icon"
                      onClick={handleLinkClick}
                    >
                      <IoCartOutline />
                    </Link>
                  )}
                </Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
      <div>{}</div>
    </>
  );
}
